import React from 'react';

// #Fase2-B3 — Mantiene los ids del catálogo; el servidor resuelve las etiquetas.
export default function ZoneSelector({ zones, zone, onChange, disabled = false }) {
  return (
    <div className="space-y-2">
      <label className="block text-sm">
        Zona
        <select className="block w-full border rounded-sm p-2" value={zone?.id || ''}
          disabled={disabled} onChange={(event) => onChange({ id: event.target.value, label: zones.find(entry => entry.id === event.target.value)?.label, detail: zone?.detail || '' })}>
          <option value="">Selecciona una zona</option>
          {zone?.id && !zones.some((entry) => entry.id === zone.id) && (
            <option value={zone.id}>{zone.label || 'Zona registrada'}</option>
          )}
          {zones.map((entry) => <option key={entry.id} value={entry.id}>{entry.label}</option>)}
        </select>
      </label>
      <label className="block text-sm">
        Detalle de la zona
        <input className="block w-full border rounded-sm p-2" value={zone?.detail || ''} maxLength={200}
          disabled={disabled || !zone?.id} onChange={(event) => onChange({ ...zone, detail: event.target.value })} />
      </label>
    </div>
  );
}
